export default __webpack_public_path__ + "static/media/bgbs.ebc5b009.jpg";